import { ROUTER_PATH } from "@/src/config";

/** `/desk/:id` — path segment 使用 encodeURIComponent */
export const buildTrackerDetailPath = (taskId: string): string =>
  `${ROUTER_PATH.DESK}/${encodeURIComponent(taskId)}`;
